import { Store } from "pullstate";

type ProcessAttendanceStoreProps = {
  organizationId: string;
  skuId: string;
};

type ProcessAttendanceExecuted = {
  processAttendanceData: ProcessAttendanceStoreProps[];
};

const processAttendanceStore = new Store<ProcessAttendanceExecuted>({
  processAttendanceData: [],
});

export default processAttendanceStore;
